import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ao{align-items:flex-start;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.dw{background:var(--palette-white);}.ssr-plugin'
import '.q{flex-direction:row;}.ssr-plugin'
import '.fn{justify-content:flex-start;}.ssr-plugin'
import '.hf{gap:2.5rem;}.ssr-plugin'
import '.c0{flex-wrap:wrap;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jt{font-size:4rem;}.ssr-plugin'
import '.d7{font-weight:700;}.ssr-plugin'
import '.ju{line-height:100%;}.ssr-plugin'
import '.gu{margin:0px;}.ssr-plugin'
import '.a1{color:var(--brand-secondary);}.ssr-plugin'
import '.a2{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="d e ao c dw"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="d q fn ao hf c0"
      >
        {items.map((item, index) => (
          <div className="d e r s"
            key={index}
          >
            <div className="jt d7 ju gu a1 a2"
            >
              {item.total}
            </div>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
